import React from 'react';
import { FileText, Image as ImageIcon } from 'lucide-react';

const AttachmentDisplay = ({ attachments, onImageClick }) => {
  if (!attachments || attachments.length === 0) return null;

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  return (
    <div className="mb-4 space-y-2">
      {attachments.map((attachment) => (
        <div key={attachment.fileId || attachment.id} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border">
          {attachment.isImage ? (
            <div className="flex items-center gap-3 flex-1">
              <ImageIcon className="w-5 h-5 text-blue-600" />
              <div className="flex-1">
                <div className="font-medium text-gray-900">{attachment.name || attachment.filename}</div>
                <div className="text-sm text-gray-500">{formatFileSize(attachment.size)}</div>
              </div>
              {attachment.url && (
                <button
                  onClick={() => onImageClick && onImageClick(attachment.url)}
                  className="px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  View
                </button>
              )}
            </div>
          ) : (
            <div className="flex items-center gap-3 flex-1">
              <FileText className="w-5 h-5 text-gray-600" />
              <div className="flex-1">
                <div className="font-medium text-gray-900">{attachment.name || attachment.filename}</div>
                <div className="text-sm text-gray-500">{formatFileSize(attachment.size)}</div>
              </div>
              {attachment.url && (
                <a
                  href={attachment.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-3 py-1.5 text-sm bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                >
                  Open
                </a>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AttachmentDisplay;